$(document).ready(function () {


    $('.init-datatable').DataTable({
        // serverSide: true
        // stateSave: true,
        responsive: true,
        pagingType: 'numbers',
        searching: false,
        info: false,
        lengthChange: false,
        columnDefs: [
            {
                "targets": 'no-sort',
                "orderable": false
            },
            {
                "targets": "no-search",
                "searchable": false
            }
        ],
        "fnDrawCallback": function (oSettings) {
            if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
            }
        }
    });

    // $('.mxm_myoda.table a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    //     $.fn.dataTable.tables({
    //         visible: true,
    //         api: true
    //     }).columns.adjust();
    // });

    if ($('#register-wrapper .af-success').length) {
        $('[data-src="#register-wrapper"]').trigger('click');
    }

    if ($('#lostpassword-wrapper .af-success').length) {
        $('[data-src="#lostpassword-wrapper"]').trigger('click');
    }



    $("a[data-delete]").on("click", function (event) {
        event.preventDefault();
        var item = $(this);
        var nonce = $('body').data('rest-nonce');
        var error = $('[data-api-error]');
        var url = item.data('url');
        var id = item.closest('tr').data('id');
        var title = item.closest('tr').find('[data-title]').text();
        url = url.replace("#id#", id);

        $.confirm({
            title: item.data('fc-title'),
            content: item.data('fc-content').replace("#title#", title),
            buttons: {
                cancel: {
                    text: item.data('fc-no'),
                    btnClass: 'mxm_button btn btn-link'
                },
                confirm: {
                    text: item.data('fc-yes'),
                    btnClass: 'mxm_button btn btn-primary',
                    action: function (confirmBtn) {
                        $.dialog({
                            title: item.data('fc-title'),
                            content: item.data('fc-success'),
                            icon: 'fal fa-spinner fa-spin',
                        });
                        $.ajax({
                                type: 'GET',
                                url: url,
                                beforeSend: function (xhr) {
                                    if (nonce && nonce.length) {
                                        xhr.setRequestHeader('X-WP-Nonce', nonce);
                                    }
                                }
                            })
                            .done(function (result) {
                                error.addClass('d-none');
                                if (result) {
                                    window.location.reload();
                                } else {
                                    error.removeClass('d-none');
                                }
                            })
                            .fail(function (result) {
                                console.warn(result);
                                error.removeClass('d-none');
                            });
                    }
                }
            }
        });
    });
});
